import {Modal} from "@tag/tag-components-react-v4";
import AppGroupService from "../../APP/services/AppGroupService";
import { ProjectAccents } from "../../General/config/projectAccents";

function APPOctoSyncAllModal(props: {
    visible: boolean,
    handleClose: Function,
    setAlert: Function,
    setLoading: Function,
    onSyncAllComplete: Function
}) {
    const renderModalContent = () => {
        return (
            <div>
                <p>
                    <strong>Syncing All</strong> covers every app group on all corporate sites that share this
                    Octopus instance, so <strong>Octopus Tenants</strong> belonging to another corporate site
                    e.g. AcrStaging are preserved.
                </p>
                <p>
                    Only tenants that no longer exist on any corporate site are removed.
                </p>
            </div>
        )
    }

    const handleOctopusSyncAll = async () => {
        props.setLoading('Starting the sync of all app groups...');
        props.handleClose();

        try {
            const task = await AppGroupService.octopusSyncForAll();
            const result = await AppGroupService.waitForOctopusSync(task.taskId,
                (message: string) => props.setLoading(message));

            props.setAlert({
                type: 'success',
                message: `All environments synced without issue - created ${result?.createdTenant ?? 0}, `
                    + `updated ${result?.updatedTenant ?? 0}, deleted ${result?.deletedTenant ?? 0} tenants`
            });
            props.onSyncAllComplete(result);
        }
        catch {
            props.setAlert({type: 'error', message: 'There was an issue with the sync, please investigate'});
        }
        finally {
            props.setLoading(false);
        }
    }

    return (
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PeoplePlanner}
            heading={'Are you sure you want to sync all App Groups?'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onPrimaryButtonClick={() => handleOctopusSyncAll()}
            onClose={() => props.handleClose()}
        >
            {renderModalContent()}
        </Modal>
    )
}

export default APPOctoSyncAllModal;
